/* ============================================================
   Manzzani — CHAROLA SERVIDA
   Un solo arreglo ordenado es la fuente de verdad. Todo lo demás
   —contador, placas, insignias, botón, resumen, propiedades—
   se deriva de él por proyección en render(). No hay segundo
   estado que sincronizar.
   ============================================================ */
(function () {
  'use strict';

  var ORDEN = ['tam', 'cla', 'pre'];   // el orden que pidió el dueño, y el de empaque

  /* MOVIMIENTO REDUCIDO. La red de mz-motion.css pone scroll-behavior:auto
     sobre todo con !important, pero esa propiedad solo decide cuando el JS
     no pide nada: un behavior:'smooth' escrito en el argumento le gana
     siempre, y ninguna regla CSS puede alcanzarlo. Quien activa "Reducir
     movimiento" —vertigo, migrana vestibular— se comia igual los tres
     desplazamientos animados de este guion, y son el camino mas transitado
     del armador: casi nadie completa la canasta al primer intento.
     Se lee una sola vez al cargar, como hace mz-app.js. */
  var REDUCE = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* El raton no deja aro de foco; el teclado si. Sirve para rescatar el
     foco solo a quien lo perderia de verdad. */
  function focoDeTeclado(el) {
    try { return !!(el && el.matches && el.matches(':focus-visible')); } catch (e) { return false; }
  }

  /* En la comunicacion el producto se llama "manzana"; "Manzzani" se reserva
     para la marca y no se usa como unidad contable. Sale en boton y avisos. */
  function pluralManzanas(n) { return n === 1 ? '1 manzana' : n + ' manzanas'; }

  /* "Chocolate Obscuro" -> "Obscuro", "Chocolate con Leche" -> "Con Leche".
     Va entre parentesis en la comanda de Liz, donde repetir la palabra
     chocolate en cada renglon solo estorba. Se capitaliza porque
     "(con Leche)" al lado de "(Blanco)" se lee descuadrado. */
  function chocoCorto(c) {
    var t = (c || '').replace(/^chocolate\s+/i, '');
    /* Misma forma que la pastilla, que usa el filtro capitalize de
       Liquid: primera en alta y el resto en baja. Si no, la comanda
       decia "Con Leche" y el boton "Con leche". */
    return t ? t.charAt(0).toUpperCase() + t.slice(1).toLowerCase() : '';
  }

  /* Clase de color del puntito. Por CONTENIDO, no por igualdad: el
     catalogo escribe "Chocolate Obscuro" pero nada impide que manana
     alguien teclee "Oscuro". */
  function chocoClase(c) {
    c = (c || '').toLowerCase();
    if (c.indexOf('blanco') >= 0) return 'blanco';
    if (c.indexOf('leche') >= 0) return 'leche';
    if (c.indexOf('scuro') >= 0) return 'obscuro';
    return '';
  }

  /* Clave de una pieza: sabor + chocolate. Dos Oreo de distinto
     chocolate son dos renglones distintos en el pedido. */
  function clavePieza(u) { return u.id + '\u0000' + (u.choc || ''); }

  class MzSabores extends HTMLElement {
    connectedCallback() {
      if (this._up) return;
      this._up = true;

      this.N     = parseInt(this.dataset.n, 10) || 0;
      this.TOTAL = parseInt(this.dataset.total, 10) || this.N;
      this.FIJAS = parseInt(this.dataset.fijas, 10) || 0;
      this.fijoNombre = this.dataset.fijoNombre || 'Tamarindo';
      this.fijoImg    = this.dataset.fijoImg || '';

      this.tray     = this.querySelector('[data-mz-tray]');
      this.titulo   = this.querySelector('[data-mz-titulo]');
      this.progress = this.querySelector('[data-mz-progress]');
      this.summary  = this.querySelector('[data-mz-summary]');
      this.propEl   = this.querySelector('[data-mz-prop]');
      this.jsonEl   = this.querySelector('[data-mz-json]');
      this.announce = this.querySelector('[data-mz-announce]');
      this.form     = this.closest('form[action*="/cart/add"]');
      this.submit   = this.form ? this.form.querySelector('[data-mz-submit]') : null;
      /* El precio del boton NO se copia aqui. Se leia una sola vez, del
         data-price que Liquid escribio con la variante por defecto, y en
         las seis canastas no habia quien lo refrescara: cambiar de
         presentacion actualizaba el precio grande de la ficha y dejaba el
         boton anunciando el de la variante inicial —"Agregar al carrito ·
         $ 2,370" con la ficha marcando $ 2,865—, justo en el renglon que se
         lee un segundo antes de pagar. Ahora lo lee render() al pintar, del
         data-price del propio boton, que es el dato que mz-app.js mantiene
         al dia; asi ninguna rama nueva puede volver a desincronizarlo. */

      // Catálogo leído del DOM: id -> {nombre, group, chocos}
      this.cat = {};
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-sabor]'));
      this.cards.forEach(function (b) {
        /* chocos sale del catalogo real y puede tener 3, 1 o ninguno:
           Tamarindo no lleva chocolate y Novia solo existe en blanco.
           Dar tres por hecho vendia variantes que no existen. */
        var cs = (b.dataset.chocos || '').split('¦').filter(function (x) { return x !== ''; });
        this.cat[b.dataset.sabor] = { nombre: b.dataset.nombre, group: b.dataset.group, chocos: cs };
      }, this);

      /* EL DIALOGO DEL CHOCOLATE. Se abre al elegir un sabor que tiene
         mas de un chocolate posible, y lo que devuelve es el chocolate
         de ESA pieza. No hay estado que recordar entre una y otra.
         'ultimoChoc' solo resalta la ultima respuesta como pista
         visual: no elige por su cuenta, sigue haciendo falta tocar. */
      this.pop      = this.querySelector('[data-mz-chocpop]');
      this.popTit   = this.querySelector('[data-mz-chocpop-tit]');
      this.popLista = this.querySelector('[data-mz-chocpop-lista]');
      this.ultimoChoc = '';
      this.pendiente  = null;   // sabor esperando respuesta
      this.volverA    = null;   // a donde devolver el foco al cerrar

      if (this.pop) {
        /* El cierre nativo —Escape o el fondo— tiene que dejar el estado
           limpio igual que Cancelar, o el siguiente toque agregaria el
           sabor que quedo pendiente del intento anterior. */
        this.pop.addEventListener('close', this.cerrarPop.bind(this));
        this.pop.addEventListener('click', function (ev) {
          if (ev.target === this.pop) this.pop.close();
        }.bind(this));
      }

      // Espejo de la propiedad vieja, para no romper las plantillas de Liz.
      if (this.dataset.oldProp === 'true' && this.form) {
        this.oldEl = document.createElement('input');
        this.oldEl.type = 'hidden';
        this.oldEl.name = 'properties[Sabores que deseas incluir en tu canasta ]';
        this.appendChild(this.oldEl);
      }

      /* Nace VACIA a proposito. Prellenada, el cliente no se entera de
         que puede elegir; los huecos numerados son la invitacion.

         Cada elemento es una PIEZA: {id, choc}. Antes era el id suelto,
         pero entonces el pedido decia "2 x Oreo" sin decir de que
         chocolate, y Liz tenia que llamar para preguntarlo. La posicion
         en el arreglo sigue siendo la posicion en la charola. */
      this.sel = [];
      this.tocada = false;

      // Mapa variante -> N. Solo los Regalos lo traen poblado.
      this.nmap = {};
      var mapEl = this.querySelector('[data-mz-nmap]');
      if (mapEl) { try { this.nmap = JSON.parse(mapEl.textContent) || {}; } catch (e) {} }

      this.addEventListener('click', this.onClick.bind(this));

      // En Regalos el tamano es variante: N cambia en vivo.
      var vsel = this.form ? (this.form.querySelector('[data-mz-variant]') ||
                             this.form.querySelector('select[name="id"]')) : null;
      if (vsel) vsel.addEventListener('change', this.onVariante.bind(this));

      this.aplicarNivel();
      this.render();
    }

    /* Que sabores caben en la variante elegida.

       Manda la COMPOSICION, no una jerarquia. El nombre de la variante
       dice exactamente cuantas de cada tipo lleva —"Premium (2 Clasicas
       y 1 Premium)"— y esos son los huecos que hay. Ni mas ni menos.

       La jerarquia "premium incluye todo lo de abajo" parecia razonable
       y estaba mal en las dos direcciones:
         · "Premium (2 Clasicas y 1 Premium)" no lleva tamarindo, pero
           la jerarquia lo daba por bueno (premium = tope 3 = todo). Se
           podia meter un tamarindo en un hueco que no existe, y los
           contadores nunca lo reconocian: canasta imposible de cerrar.
         · "Clasicas (1 de Tamarindo, 1 Clasica y 1 Premium)" SI lleva
           una premium, pero la jerarquia escondia el grupo Premium. Ese
           hueco no habia forma de llenarlo.
       La composicion ya se leia bien para pintar los contadores; solo
       le faltaba mandar tambien aqui.

       Cuando no hay parentesis que leer —productos simples— se cae a la
       jerarquia, que para ese caso si describe la realidad.

       Lo que no cabe no se vela al 40%: se quita. Un sabor medio
       apagado invita a intentarlo y a chocar con un error. */
    aplicarNivel() {
      if (this.dataset.pool === 'tamarindo') return;   // aqui la galeria ya viene acotada

      var CLAVE = { tamarindo: 'tam', clasica: 'cla', premium: 'pre' };
      var comp = this.form ? this.composicionDeVariante() : null;
      var cabe;

      if (comp) {
        cabe = { tam: (comp.tam || 0) > 0, cla: (comp.cla || 0) > 0, pre: (comp.pre || 0) > 0 };
      } else {
        var nivel = this.form ? this.nivelDeVariante() : 'premium';

        /* UNA SOLA MANZZANI NO SE MEZCLA CONSIGO MISMA.

           La jerarquia "premium incluye lo de abajo" describe una
           canasta que se puede combinar; una pieza suelta no. Aplicada
           a "Manzana Individual Premium" —$235— abria tambien Clasicas
           y Tamarindo, y se podia pagar Premium para acabar eligiendo
           un Tamarindo de $100. La linea que nombra la variante es la
           unica que cabe.

           Con mas de una pieza y sin composicion declarada, la
           jerarquia si describe la realidad y se conserva. */
        if (this.N === 1) {
          var solo = CLAVE[nivel] || 'pre';
          cabe = { tam: solo === 'tam', cla: solo === 'cla', pre: solo === 'pre' };
        } else {
          var RANGO = { tamarindo: 1, clasica: 2, premium: 3 };
          var tope = RANGO[nivel] || 3;
          cabe = { tam: tope >= 1, cla: tope >= 2, pre: tope >= 3 };
        }
      }

      this.querySelectorAll('[data-tier]').forEach(function (el) {
        el.hidden = !cabe[CLAVE[el.getAttribute('data-tier')]];
      });

      /* DENTRO DE TAMARINDO: sencilla o con ingrediente, nunca las dos.

         Se aplica solo cuando la variante es de tamarindo y de nada
         mas —la Manzzani suelta y la Canasta Individual—, que es donde
         el precio distingue una de otra. En una canasta compuesta
         ("2 de Tamarindo, 2 Clasicas...") el precio ya esta cerrado y
         se sigue pudiendo mezclar, como hasta ahora.

         Los renglones de ingrediente traen sid 'tam-<algo>'; la
         sencilla es 'tamarindo' a secas. Es el mismo reparto que hace
         la Canasta Doble Tamarindo, solo que alli lo deciden los
         metacampos de la variante y aqui la linea elegida. */
      var soloTam = cabe.tam && !cabe.cla && !cabe.pre;
      var extra = soloTam ? this.tamarindoConExtra() : null;
      var permitido = {};
      this.querySelectorAll('.mz-sab__group[data-group="tam"] .mz-sab__row').forEach(function (row) {
        var b = row.querySelector('[data-sabor]');
        if (!b) return;
        var sid = b.dataset.sabor;
        var esExtra = sid.indexOf('tam-') === 0;
        var ok = (extra === null) || (extra ? esExtra : !esExtra);
        row.hidden = !ok;
        permitido[sid] = ok;
      });

      /* Lo ya puesto que deje de ofrecerse se retira, o quedaria en la
         charola una pieza que la linea nueva no cubre. */
      if (extra !== null) {
        var fuera = 0, self2 = this;
        this.sel = this.sel.filter(function (u) {
          var g = self2.cat[u.id] ? self2.cat[u.id].group : null;
          if (g !== 'tam') return true;
          if (permitido[u.id]) return true;
          fuera++;
          return false;
        });
        if (fuera) {
          this.decir('Quitamos ' + fuera + (fuera === 1 ? ' manzana que no' : ' manzanas que no') +
                     ' entra' + (fuera === 1 ? '' : 'n') + ' en esta línea.');
        }
      }
      var same = this.querySelector('.mz-sab__samep');
      if (same) same.hidden = !cabe.pre;   // el precio solo se menciona donde existe la duda

      // Lo ya elegido que se salga de la nueva composicion se retira y se dice.
      var quitados = 0, self = this;
      this.sel = this.sel.filter(function (u) {
        var g = self.cat[u.id] ? self.cat[u.id].group : null;
        var ok = !g || cabe[g];
        if (!ok) quitados++;
        return ok;
      });
      if (quitados) {
        this.decir('Quitamos ' + quitados + ' ' + (quitados === 1 ? 'sabor que no' : 'sabores que no') +
                   ' entra' + (quitados === 1 ? '' : 'n') + ' en esta línea. Elige ' + quitados + ' más.');
      }

      /* ...Y TAMBIEN LO QUE SOBRA DE CUPO.

         El filtro de arriba solo mira si el grupo sigue EXISTIENDO en la
         composicion nueva. Yendo de "Premium (6 Clásicas y 6 Premium)" a
         "Clásicas (4 de Tamarindo, 4 Clásicas y 4 Premium)" los tres grupos
         existen en las dos, asi que no se quitaba nada ni se decia nada, y
         el cliente aterrizaba en una charola llena e imposible: doce de
         doce puestas, el boton pidiendo cuatro Tamarindo y ni un hueco
         donde meterlos. Se recortan las ULTIMAS de cada grupo pasado de
         cupo —las primeras son las que eligio antes— y se avisa, para que
         se entere de que le quitamos dos Clásicas en vez de descubrirlo
         peleandose con el boton. */
      if (comp) {
        var vistas = {}, sobran = 0, guarda = [];
        // De adelante hacia atras: se conservan las PRIMERAS de cada grupo y
        // caen las ultimas, igual que hace onVariante cuando la canasta
        // encoge. Quitar las primeras seria borrarle lo que eligio antes.
        for (var k = 0; k < this.sel.length; k++) {
          var pz = this.sel[k];
          var gp = this.cat[pz.id] ? this.cat[pz.id].group : null;
          var cupo = (gp && comp[gp] != null) ? comp[gp] : null;
          if (cupo === null) { guarda.push(pz); continue; }   // sin grupo: no hay cupo que aplicar
          vistas[gp] = (vistas[gp] || 0) + 1;
          if (vistas[gp] > cupo) { sobran++; continue; }
          guarda.push(pz);
        }
        if (sobran) {
          this.sel = guarda;
          var pendientes = this.N - this.sel.length;
          this.decir('Esta presentación lleva otra mezcla: quitamos ' +
                     (sobran === 1 ? '1 manzana que ya no cabía' : sobran + ' manzanas que ya no cabían') +
                     '. Te ' + (pendientes === 1 ? 'falta ' : 'faltan ') + pluralManzanas(pendientes) +
                     ' por elegir.');
        }
      }
    }

    /* De donde sale el nivel.

       1) Si quien manda la variante ya sabe la linea —el selector por
          pasos de Regalos la escribe en data-nivel— se cree eso. Es un
          dato, no una adivinanza sobre un texto.
       2) Si no, se lee el nombre. Y NO con /premium/i: "Canasta de 3
          Clásicas (1 de Tamarindo, 1 Clásica y 1 Premium)" contiene la
          palabra Premium y es clasica. La linea la marca la palabra que
          va pegada al numero o a "Individual". */
    /* La composicion que promete la variante.

       El nombre la trae entre parentesis: "Clásicas (1 de Tamarindo,
       2 Clásicas y 1 Premium)". Se lee SOLO lo de dentro del parentesis:
       fuera esta "de 4 Clásicas", que es el total y no una linea, y
       contarlo daria cuatro clasicas donde hay dos.

       Si no hay parentesis —"Canasta Individual Premium"— no hay
       composicion que enseñar y el bloque se queda oculto. */
    /* Lee la composicion de UN nombre de variante. Separado para poder
       aplicarlo tambien al nombre de una variante hermana. */
    leerComposicion(txt) {
      var m = (txt || '').match(/\(([^)]*)\)/);
      if (!m) return null;
      var dentro = m[1];
      if (/botella/i.test(dentro)) return null;   // "(con Espacio para Botella)" no es composicion

      var comp = {};
      var tam = dentro.match(/(\d+)\s*(?:de\s+)?Tamarindo/i);
      var cla = dentro.match(/(\d+)\s*(?:de\s+)?Cl[áa]sicas?/i);
      var pre = dentro.match(/(\d+)\s*(?:de\s+)?Premium/i);
      if (tam) comp.tam = parseInt(tam[1], 10);
      if (cla) comp.cla = parseInt(cla[1], 10);
      if (pre) comp.pre = parseInt(pre[1], 10);
      return Object.keys(comp).length ? comp : null;
    }

    /* Una composicion solo se cree si SUMA lo que la canasta pide.

       "Canasta Doble" tiene la variante «Clásicas (1 de tamarindo y 1 de
       chocolate)»: es la unica del catalogo cuyo parentesis nombra un
       SABOR donde las demas nombran una LINEA. Las expresiones leen
       "1 de tamarindo" y no encuentran clasicas ni premium, asi que
       devuelven {tam:1} para una canasta de dos. Con eso, aplicarNivel
       escondia Clasicas y Premium, el cap pintaba "0 de 1 Tamarindo" en
       una canasta de 2, y el boton se habilitaba igual —solo mira que
       se hayan elegido N— dejando cerrar la compra con DOS tamarindos
       sobre una variante que promete uno de tamarindo y uno de
       chocolate. Un pedido que Liz no puede surtir como se vendio.

       Una composicion a medias es peor que ninguna: manda a una pantalla
       imposible de completar. Si no cuadra se descarta y se cae al
       respaldo jerarquico, que para «Clásicas» ofrece tamarindo y
       clasicas —que es justo lo que esa canasta lleva.

       Se acepta contra el total del canasto o contra lo que toca elegir:
       cuando hay manzanas fijas los dos numeros no coinciden y ambos son
       lecturas legitimas.

       Se miran this.TOTAL y this.N, NO los data-* del elemento. En
       Regalos el tamaño cambia sin recargar: onVariante actualiza las
       propiedades vivas desde el mapa de variantes y deja los atributos
       como nacieron. Leyendo el atributo, una "Canasta de 2" se comparaba
       contra el 1 de la variante inicial y se descartaba una composicion
       perfectamente buena, dejando a los diez productos de Regalos sin
       contadores por tipo. aplicarNivel() corre al final de onVariante,
       ya con ambas actualizadas. */
    soloSiCuadra(comp) {
      if (!comp) return null;
      var suma = (comp.tam || 0) + (comp.cla || 0) + (comp.pre || 0);
      if (suma === this.TOTAL || suma === this.N) return comp;
      return null;
    }

    /* ─── EL CUPO POR TIPO SE APLICA, NO SOLO SE ENSEÑA ───────────────

       La composicion decia "0 de 2 Clásicas, 0 de 1 Premium" y no
       impedia nada: agregar() solo miraba el TOTAL. En una Canasta de
       Cuatro Clásicas ($890, que lleva 1 Tamarindo, 2 Clásicas y 1
       Premium) se podian meter TRES Premium y cerrar la compra. Liz
       entregaba tres premium cobradas a precio de clasica.

       Estas tres funciones son la fuente unica: cuanto cabe de cada
       tipo, cuanto se lleva, y si la canasta esta realmente lista. */
    /* "Te falta 1 Clásicas" chirria. Solo Clásicas tiene singular
       distinto; Tamarindo y Premium no cambian. */
    NOMBRE_GRUPO(g, n) {
      var uno = { tam: 'Tamarindo', cla: 'Clásica', pre: 'Premium' };
      var varias = { tam: 'Tamarindo', cla: 'Clásicas', pre: 'Premium' };
      return (n === 1 ? uno : varias)[g] || g;
    }

    /* null = esta variante no declara composicion; entonces manda solo
       el total y se puede elegir libremente, como siempre. */
    cupos() {
      return this.composicionDeVariante();
    }

    cuentaPorGrupo() {
      var self = this, c = {};
      this.sel.forEach(function (u) {
        var g = self.cat[u.id] && self.cat[u.id].group;
        if (g) c[g] = (c[g] || 0) + 1;
      });
      return c;
    }

    /* Lo que falta para que la canasta cuadre con lo que promete.
       Devuelve [] cuando esta lista. */
    faltantes() {
      var comp = this.cupos();
      if (!comp) return [];
      var lleva = this.cuentaPorGrupo(), self = this, out = [];
      ['tam', 'cla', 'pre'].forEach(function (g) {
        if (comp[g] == null) return;
        var d = comp[g] - (lleva[g] || 0);
        if (d > 0) out.push({ g: g, faltan: d, nombre: self.NOMBRE_GRUPO(g, d) });
      });
      return out;
    }

    /* "1 Tamarindo y 1 Clásica y 1 Premium" no es español. Comas entre
       todas y la "y" solo antes de la ultima. */
    listar(partes) {
      if (partes.length <= 1) return partes.join('');
      return partes.slice(0, -1).join(', ') + ' y ' + partes[partes.length - 1];
    }

    /* ─── DESPLEGABLES: UN GRUPO ABIERTO A LA VEZ ────────────────────

       Con treinta y pico de sabores en tres grupos, tenerlos todos
       abiertos son cuatro mil pixeles de scroll para elegir cuatro
       Manzzanis. En acordeon solo se ve el grupo que toca.

       Las reglas, para que no se mueva solo de forma imprevisible:
         · Al entrar se abre el primero al que le falten Manzzanis.
         · Al llenarse el abierto, pasa al siguiente que falte. Es el
           unico movimiento automatico y siempre va hacia adelante.
         · Tocar una cabecera manda por encima de todo (this.forzado):
           si la persona cierra, se queda cerrado. */
    gruposPlegables() {
      return Array.prototype.filter.call(this.querySelectorAll('.mz-sab__group'), function (g) {
        return !g.hidden && g.querySelector('[data-mz-gtoggle]');
      });
    }

    grupoLleno(gid, porGrupo) {
      var comp = this.cupos();
      if (!comp || comp[gid] == null) return false;
      return (porGrupo[gid] || 0) >= comp[gid];
    }

    pintarDesplegables(porGrupo) {
      var gs = this.gruposPlegables();
      if (!gs.length) return;
      var self = this;
      var falta = function (g) { return !self.grupoLleno(g.dataset.group, porGrupo); };

      var vigente = this.abierto;
      var sigueAhi = gs.some(function (g) { return g.dataset.group === vigente; });
      if (!sigueAhi) vigente = null;

      // Se llenó el que estaba abierto: adelante, y se suelta el mando
      // manual porque el movimiento lo pidio el propio avance.
      if (vigente && self.grupoLleno(vigente, porGrupo)) { vigente = null; this.forzado = false; }

      if (!vigente && !this.forzado) {
        var pend = gs.filter(falta)[0];
        vigente = pend ? pend.dataset.group : null;
      }
      this.abierto = vigente;

      gs.forEach(function (g) {
        var gid = g.dataset.group;
        var btn = g.querySelector('[data-mz-gtoggle]');
        var filas = g.querySelector('.mz-sab__rows');
        var on = gid === vigente;
        if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (filas) filas.hidden = !on;
        g.classList.toggle('is-abierto', on);
        g.classList.toggle('is-completo', !falta(g));
      });
    }

    composicionCumplida() {
      var comp = this.cupos();
      if (!comp) return this.sel.length === this.N;
      var lleva = this.cuentaPorGrupo();
      for (var g in comp) {
        if (comp[g] == null) continue;
        if ((lleva[g] || 0) !== comp[g]) return false;
      }
      return this.sel.length === this.N;
    }

    /* La cabecera de un nombre de variante: lo de ANTES del parentesis.
       Es lo que identifica la linea, y es donde se pueden comparar dos
       hermanas. */
    cabeceraDe(txt) {
      return (txt || '').split('(')[0].trim().toUpperCase();
    }

    composicionDeVariante() {
      var sel = this.form && (this.form.querySelector('[data-mz-variant]') ||
                              this.form.querySelector('select[name="id"]'));
      if (!sel) return null;
      var txt = '';
      if (sel.tagName === 'SELECT' && sel.selectedOptions[0]) txt = sel.selectedOptions[0].textContent;
      else txt = sel.dataset.title || '';

      var propia = this.leerComposicion(txt);
      if (propia) return this.soloSiCuadra(propia);

      /* Las variantes "(con Espacio para Botella)" no traen composicion
         en el nombre: el parentesis lo ocupa la botella. Sin esto caian
         al respaldo jerarquico, que escondia el grupo Premium y dejaba
         un hueco imposible de llenar.

         La composicion se hereda de la hermana de la MISMA linea que si
         la trae. No es una suposicion: la de botella pide las mismas
         manzanas —en la de tres, data-total vale 3 en ambas—; lo unico
         que cambia es que el canasto tiene hueco para la botella. */
      if (!/botella/i.test(txt)) return null;
      var datos = this.form.querySelector('[data-mz-variants]');
      if (!datos) return null;
      var lista;
      try { lista = JSON.parse(datos.textContent); } catch (e) { return null; }
      if (!Array.isArray(lista)) return null;

      var cab = this.cabeceraDe(txt), self = this;
      for (var i = 0; i < lista.length; i++) {
        var otro = lista[i] && lista[i].t;
        if (!otro || self.cabeceraDe(otro) !== cab) continue;
        var heredada = self.leerComposicion(otro);
        if (heredada) return self.soloSiCuadra(heredada);
      }
      return null;
    }

    pintarComposicion(porGrupo) {
      var caja = this.querySelector('[data-mz-cap]');
      var lista = this.querySelector('[data-mz-cap-lista]');
      if (!caja || !lista) return;

      var comp = this.composicionDeVariante();
      caja.hidden = !comp;
      this.querySelectorAll('[data-mz-gtarget]').forEach(function (el) { el.hidden = true; });
      if (!comp) return;

      var NOMBRE = { tam: 'Tamarindo', cla: 'Clásicas', pre: 'Premium' };
      var html = '';
      ['tam', 'cla', 'pre'].forEach(function (g) {
        if (comp[g] == null) return;
        var llevas = (porGrupo && porGrupo[g]) || 0;
        var listo = llevas === comp[g];
        html += '<li class="mz-sab__cap-item' + (listo ? ' is-listo' : '') + '">' +
                '<b>' + llevas + ' de ' + comp[g] + '</b> ' + NOMBRE[g] + '</li>';
      });
      lista.innerHTML = html;

      // El mismo dato repetido junto al titulo del grupo, para no obligar
      // a subir a la cabecera cada vez que se agrega una.
      var self = this;
      Object.keys(comp).forEach(function (g) {
        var el = self.querySelector('[data-mz-gtarget="' + g + '"]');
        if (!el) return;
        el.hidden = false;
        el.textContent = ' / ' + comp[g];
      });
    }

    /* El nombre de la variante viva. Se leia igual en tres sitios. */
    textoDeVariante() {
      var sel = this.form && (this.form.querySelector('[data-mz-variant]') ||
                              this.form.querySelector('select[name="id"]'));
      if (!sel) return '';
      if (sel.tagName === 'SELECT' && sel.selectedOptions[0]) return sel.selectedOptions[0].textContent;
      return sel.dataset.title || '';
    }

    /* Tamarindo tiene DOS precios: la sencilla y la que lleva ingrediente
       extra. En Regalos son $125 y $150 en canasta, $100 y $130 sueltas.

       Devuelve true (con extra), false (sencilla) o null (no aplica,
       porque la variante no es una linea de tamarindo).

       El dato preferente lo manda mz-regalos.js en data-tam-extra,
       porque el propio guion normaliza 'tam-extra' a 'tamarindo' al
       escribir data-nivel y ahi se pierde. Si no viene, se lee el
       nombre, que es como funciona la Canasta Doble Tamarindo. */
    tamarindoConExtra() {
      var sel = this.form && (this.form.querySelector('[data-mz-variant]') ||
                              this.form.querySelector('select[name="id"]'));
      if (sel && sel.dataset && sel.dataset.tamExtra) return sel.dataset.tamExtra === '1';

      var txt = this.textoDeVariante();
      if (!/tamarindo/i.test(txt)) return null;
      return /ingrediente/i.test(txt);
    }

    nivelDeVariante() {
      var sel = this.form.querySelector('[data-mz-variant]') ||
                this.form.querySelector('select[name="id"]');
      if (!sel) return 'premium';

      if (sel.dataset && sel.dataset.nivel) return sel.dataset.nivel;

      var txt = this.textoDeVariante();

      /* La linea la marca lo que va ANTES del parentesis. Dentro del
         parentesis se detalla la mezcla —"Clásicas (1 de Tamarindo,
         2 Clásicas y 1 Premium)"— y ahi aparecen las tres palabras:
         mirarlo entero clasificaba mal casi todo. */
      var cab = txt.split('(')[0];
      if (/premium/i.test(cab)) return 'premium';
      if (/cl[áa]sica/i.test(cab)) return 'clasica';
      if (/tamarindo/i.test(cab)) return 'tamarindo';
      return 'premium';   // sin pistas, lo mas permisivo: no bloquear una venta
    }

    /* Cambio de variante. Si N crece, las posiciones nuevas se rellenan
       con la mezcla de la casa; si baja, se recorta por el final.
       Nunca se vacia todo y nunca se bloquea el cambio. */
    onVariante(ev) {
      /* El precio, LO PRIMERO, antes de cualquier atajo. Este refresco
         vivia al final del metodo, detras del return de tres renglones mas
         abajo, y ese return se toma SIEMPRE en las seis canastas —su
         data-mz-nmap sirve literalmente "{}"—, asi que el precio del boton
         no se tocaba nunca. Se escribe en el data-price del propio boton,
         que es de donde render() lo lee, y no en una copia: asi tambien
         queda al dia en Regalos, donde mz-regalos.js mueve la variante y no
         toca el boton.
         Con pastillas el emisor es un input hidden: no hay selectedOptions. */
      var opt = ev.target.selectedOptions && ev.target.selectedOptions[0];
      var precio = (opt && opt.dataset.price) || ev.target.dataset.price;
      if (precio && this.submit) this.submit.dataset.price = precio.replace(/<[^>]*>/g, '');

      var info = this.nmap[ev.target.value];
      var nuevoN = info ? info.n : undefined;
      if (nuevoN === undefined) { this.aplicarNivel(); this.render(); return; }

      this.TOTAL = info.total || nuevoN;
      this.FIJAS = Math.max(0, this.TOTAL - nuevoN);

      if (nuevoN === this.N) { this.aplicarNivel(); this.render(); return; }

      var antes = this.N;
      this.N = nuevoN;

      if (nuevoN > antes) {
        var faltan = nuevoN - this.sel.length;
        if (faltan > 0) {
          this.decir('Ahora eliges ' + (faltan === 1 ? '1 manzana.' : faltan + ' manzanas.'));
        }
      } else {
        var quita = this.sel.length - nuevoN;
        if (quita > 0) {
          this.sel.length = nuevoN;
          this.decir('Ahora son ' + nuevoN + (nuevoN === 1 ? ' manzana' : ' manzanas') +
                     '. Quitamos ' + (quita === 1 ? 'la ultima' : 'las ultimas ' + quita) + '.');
        }
      }

      // El titulo cuenta la canasta COMPLETA, no lo elegible: la Doble
      // Tamarindo con una fija es "de 2" aunque solo elijas una.
      if (this.titulo) this.titulo.textContent = 'Arma tu canasta de ' + this.TOTAL;

      this.aplicarNivel();
      this.render();
    }

    onClick(ev) {
      var tog = ev.target.closest('[data-mz-gtoggle]');
      if (tog) {
        var gid = tog.dataset.mzGtoggle;
        this.abierto = this.abierto === gid ? null : gid;
        this.forzado = true;      // lo que decida la persona, manda
        this.render();
        return;
      }

      /* Respuesta del dialogo del chocolate. */
      var chip = ev.target.closest('[data-choc]');
      if (chip) { this.responderChoc(chip.dataset.choc); return; }
      if (ev.target.closest('[data-mz-chocpop-cerrar]')) {
        if (this.pop) this.pop.close();
        return;
      }

      var add = ev.target.closest('[data-sabor]');
      var minus = ev.target.closest('[data-minus]');
      var slot = ev.target.closest('[data-slot]');
      var jump = ev.target.closest('[data-jump]');

      if (jump) {
        var g = this.querySelector('[data-group="' + jump.dataset.jump + '"]');
        if (g) g.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'start' });
        return;
      }
      if (add)   { this.agregar(add.dataset.sabor); return; }
      if (minus) { this.quitar(minus.dataset.minus); return; }
      if (slot)  { this.quitarPos(parseInt(slot.dataset.slot, 10)); return; }
    }

    /* Charola llena: no se bloquea ni se avisa. Sustituye la última. */
    agregar(id) {
      var info = this.cat[id]; if (!info) return;
      this.tocada = true;

      /* Pasarse del cupo de un tipo es justo lo que hacia perder dinero:
         se para aqui y se dice por que, en vez de dejar llegar al carrito
         una canasta que no corresponde a lo que se cobro. */
      var comp = this.cupos();
      if (comp && info.group) {
        var cupo = comp[info.group] == null ? 0 : comp[info.group];
        var lleva = this.cuentaPorGrupo()[info.group] || 0;
        if (lleva >= cupo) {
          this.decir(cupo === 0
            ? 'Esta canasta no lleva ' + this.NOMBRE_GRUPO(info.group, 2) + '.'
            : 'Esta canasta lleva ' + cupo + ' ' + this.NOMBRE_GRUPO(info.group, cupo) +
              '. Quita una para cambiarla.');
          this.render();
          return;
        }
      }

      /* El chocolate de ESTA pieza. Manda el catalogo del sabor:
           · varios chocolates -> se PREGUNTA, y el alta se termina en
             responderChoc(). Aqui se sale sin agregar nada.
           · uno solo (Novia, blanco) -> ese lleva, sin preguntar.
           · ninguno (Tamarindo) -> entra vacio.
         Preguntar cuando no hay eleccion posible seria un toque de mas
         y una respuesta obvia. */
      var cs = info.chocos || [];
      if (cs.length > 1) { this.abrirPop(id, info, cs); return; }

      this.meter(id, cs.length === 1 ? cs[0] : '');
    }

    /* ─── EL DIALOGO DEL CHOCOLATE ───────────────────────────────────── */

    abrirPop(id, info, cs) {
      if (!this.pop || !this.popLista) { this.meter(id, cs[0]); return; }

      this.pendiente = id;
      this.volverA = document.activeElement;   // para devolver el foco al cerrar
      if (this.popTit) this.popTit.textContent = info.nombre;

      var self = this, html = '';
      cs.forEach(function (c) {
        html += '<button type="button" class="mz-chocpop__op' +
                (c === self.ultimoChoc ? ' is-ultimo' : '') +
                '" data-choc="' + c.replace(/"/g, '&quot;') + '">' +
                '<span class="mz-chocpop__punto" data-choc-punto="' + chocoClase(c) +
                '" aria-hidden="true"></span>' +
                '<span>' + chocoCorto(c) + '</span></button>';
      });
      this.popLista.innerHTML = html;

      if (typeof this.pop.showModal === 'function') this.pop.showModal();
      else this.pop.setAttribute('open', '');   // respaldo si no hay dialog nativo

      var primero = this.popLista.querySelector('.is-ultimo') ||
                    this.popLista.querySelector('.mz-chocpop__op');
      if (primero) primero.focus();
    }

    responderChoc(choc) {
      var id = this.pendiente;
      this.ultimoChoc = choc;
      if (this.pop && this.pop.open) this.pop.close();   // close() dispara cerrarPop
      else this.cerrarPop();
      if (id) this.meter(id, choc);
    }

    /* Cancelar, Escape y el clic en el fondo acaban aqui: se suelta el
       pendiente para que el siguiente toque empiece limpio. */
    cerrarPop() {
      this.pendiente = null;
      if (this.volverA && typeof this.volverA.focus === 'function') {
        try { this.volverA.focus(); } catch (e) {}
      }
      this.volverA = null;
    }

    /* El alta de verdad, ya con el chocolate decidido. */
    meter(id, choc) {
      var info = this.cat[id]; if (!info) return;
      var dice = info.nombre + (choc ? ' en ' + choc.toLowerCase() : '');

      if (this.sel.length >= this.N) {
        /* Charola llena. SIN composicion, sustituir la ultima metida es lo
           correcto y es lo que la gente espera. CON composicion no: si la
           ultima metida resulta ser justo del tipo que falta, el alta se
           come a si misma y el contador no avanza nunca —tocar Tamarindo
           diez veces dejaba "1 de 4 Tamarindo" y el boton repitiendo "Te
           faltan 3 Tamarindo"—. Se expulsa entonces la ultima pieza de un
           grupo PASADO de cupo, que es la que de verdad estorba, y solo se
           cae a la ultima a secas cuando no sobra ninguna. */
        var pos = this.sel.length - 1;
        var comp = this.cupos();
        if (comp) {
          var lleva = this.cuentaPorGrupo();
          for (var k = this.sel.length - 1; k >= 0; k--) {
            var gk = this.cat[this.sel[k].id] ? this.cat[this.sel[k].id].group : null;
            var cupok = (gk && comp[gk] != null) ? comp[gk] : 0;
            if (gk && (lleva[gk] || 0) > cupok) { pos = k; break; }
          }
        }
        var fuera = this.sel.splice(pos, 1)[0];
        this.sel.push({ id: id, choc: choc });
        var nf = this.cat[fuera.id] ? this.cat[fuera.id].nombre : fuera.id;
        this.decir(nf + ' cambiada por ' + dice + '. ' + this.N + ' de ' + this.N + '.');
      } else {
        this.sel.push({ id: id, choc: choc });
        this.decir(dice + ' agregada. ' + this.sel.length + ' de ' + this.N + '.');
      }
      this.render();
    }

    /* El menos del renglon quita la ULTIMA pieza de ese sabor, sea cual
       sea su chocolate: el renglon cuenta el sabor, no la combinacion.
       Para quitar una concreta esta el toque sobre el hueco. */
    quitar(id) {
      var i = -1;
      for (var k = this.sel.length - 1; k >= 0; k--) {
        if (this.sel[k].id === id) { i = k; break; }
      }
      if (i < 0) return;
      this.tocada = true;
      this.sel.splice(i, 1);
      this.decir((this.cat[id] ? this.cat[id].nombre : id) + ' quitada. ' + this.sel.length + ' de ' + this.N + '.');
      this.render();
    }

    quitarPos(i) {
      if (i < 0 || i >= this.sel.length) return;
      this.tocada = true;
      var u = this.sel[i];
      this.sel.splice(i, 1);   // la charola se recompacta: no quedan huecos intermedios
      this.decir((this.cat[u.id] ? this.cat[u.id].nombre : u.id) + ' quitada. ' + this.sel.length + ' de ' + this.N + '.');
      this.render();
    }

    /* Agrupa por SABOR + CHOCOLATE, conservando el orden tam -> cla -> pre.

       La clave lleva el chocolate porque dos Oreo de distinto chocolate
       son dos cosas distintas en la cocina: si se colapsaran en "2 x
       Oreo" el pedido volveria a esconder justo el dato que faltaba. */
    agrupado() {
      var cuenta = {}, meta = {}, self = this;
      this.sel.forEach(function (u) {
        var k = clavePieza(u);
        cuenta[k] = (cuenta[k] || 0) + 1;
        meta[k] = u;
      });
      return Object.keys(cuenta)
        .sort(function (a, b) {
          var ia = meta[a].id, ib = meta[b].id;
          var ga = ORDEN.indexOf(self.cat[ia] ? self.cat[ia].group : 'cla');
          var gb = ORDEN.indexOf(self.cat[ib] ? self.cat[ib].group : 'cla');
          if (ga !== gb) return ga - gb;
          var na = self.cat[ia] ? self.cat[ia].nombre : ia;
          var nb = self.cat[ib] ? self.cat[ib].nombre : ib;
          if (na !== nb) return na.localeCompare(nb, 'es');
          return (meta[a].choc || '').localeCompare(meta[b].choc || '', 'es');
        })
        .map(function (k) {
          var u = meta[k];
          return {
            id: u.id,
            n: cuenta[k],
            choc: u.choc || '',
            nombre: self.cat[u.id] ? self.cat[u.id].nombre : u.id
          };
        });
    }

    /* El sufijo de precio del boton, leido EN EL MOMENTO de pintar. Sin
       copia guardada: el unico dato al dia es el data-price del propio
       boton, que mz-app.js reescribe en cada cambio de variante. */
    precioSufijo() {
      var p = this.submit ? (this.submit.dataset.price || '') : '';
      return p ? ' · ' + p : '';
    }

    render() {
      var self = this, faltan = this.N - this.sel.length;

      /* Quien tenia el foco ANTES de que este mismo render() apague las
         filas del grupo que se acaba de llenar y esconda su lista. Al
         deshabilitar y ocultar el boton enfocado el navegador se queda sin
         donde ponerlo y lo manda al <body>: quien elige con teclado pierde
         el sitio en cada Manzzani y puede acabar teniendo que cruzar otra
         vez encabezado y menu para poner la siguiente. Se anota aqui y se
         rescata al final, cuando ya se sabe que grupo abrio el acordeon.
         Solo se rescata al teclado: al raton un salto de foco solo le
         daria un tiron de pagina que nadie pidio. */
      var focoPrevio = document.activeElement;
      if (!(focoPrevio && this.contains(focoPrevio) && focoDeTeclado(focoPrevio))) focoPrevio = null;

      /* Sin nada que elegir ("Dos Sencillas": el nombre lo dice todo)
         el selector no se muestra. No se desmonta: cambiar de variante
         lo vuelve a traer sin recargar. */
      this.hidden = this.N === 0;
      if (this.N === 0) {
        if (this.propEl) this.propEl.value = '';
        if (this.jsonEl) this.jsonEl.value = '';
        if (this.oldEl)  this.oldEl.value  = '';
        if (this.submit) {
          this.submit.textContent = 'Agregar al carrito' + this.precioSufijo();
          this.submit.classList.add('mz-btn--accent');
          this.submit.classList.remove('mz-btn--ghost');
          this.submit.setAttribute('aria-disabled', 'false');
        }
        return;
      }

      if (this.titulo) this.titulo.textContent = 'Arma tu canasta de ' + this.TOTAL;

      /* Charola. Las fijas van primero, con candado: vienen incluidas
         en la canasta y no se eligen ni se quitan. */
      var html = '';
      for (var f = 0; f < this.FIJAS; f++) {
        html += '<li class="mz-sab__slot is-full is-fija" aria-label="'
              + this.fijoNombre + ', incluida">'
              + (this.fijoImg ? '<img src="' + this.fijoImg + '" alt="" loading="lazy">'
                              : '<span class="mz-sab__noimg">' + this.fijoNombre + '</span>')
              + '<span class="mz-sab__lock" aria-hidden="true">'
              + '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
              + ' stroke-width="2.5" stroke-linecap="round"><path d="M7 11V8a5 5 0 0 1 10 0v3"/>'
              + '<rect x="4" y="11" width="16" height="10" rx="2"/></svg></span></li>';
      }
      for (var i = 0; i < this.N; i++) {
        var u = this.sel[i];
        if (u) {
          var id = u.id;
          var src = '', card = this.querySelector('[data-sabor="' + CSS.escape(id) + '"] img');
          if (card) src = card.currentSrc || card.src;
          var nom = this.cat[id] ? this.cat[id].nombre : id;
          /* El chocolate se ve en el hueco, no solo en el resumen: es
             donde la persona mira mientras arma, y es el unico sitio
             donde se distingue una pieza de otra del mismo sabor. */
          var cls = chocoClase(u.choc);
          var punto = cls
            ? '<span class="mz-sab__slotchoc" data-choc-punto="' + cls + '" aria-hidden="true"></span>'
            : '';
          html += '<li class="mz-sab__slot is-full"><button type="button" data-slot="' + i + '"'
                + ' aria-label="Quitar ' + nom + (u.choc ? ' en ' + u.choc.toLowerCase() : '')
                + ' de la posición ' + (i + 1) + '">'
                + (src ? '<img src="' + src + '" alt="" loading="lazy">'
                       : '<span class="mz-sab__noimg">' + nom + '</span>')
                + punto
                + '</button></li>';
        } else {
          html += '<li class="mz-sab__slot"><span class="mz-sab__num">' + (this.FIJAS + i + 1) + '</span></li>';
        }
      }
      this.tray.innerHTML = html;

      /* Contadores por fila, por linea y global */
      /* El contador del renglon suma el sabor entero, con cualquier
         chocolate: el renglon ES el sabor. El desglose por chocolate
         vive en la charola y en el resumen. */
      var cuenta = {};
      this.sel.forEach(function (u) { cuenta[u.id] = (cuenta[u.id] || 0) + 1; });

      var porGrupo = {};
      Array.prototype.forEach.call(this.querySelectorAll('.mz-sab__row'), function (row) {
        var add = row.querySelector('[data-sabor]');
        if (!add) return;
        var c = cuenta[add.dataset.sabor] || 0;

        var num = row.querySelector('[data-count]');
        if (num) num.textContent = c;
        row.classList.toggle('is-on', c > 0);

        // El menos se oculta con visibility, no con display: si desapareciera
        // el renglon cambiaria de ancho y el + bailaria bajo el cursor.
        var menos = row.querySelector('[data-minus]');
        if (menos) { menos.hidden = c === 0; menos.disabled = c === 0; }

        Array.prototype.forEach.call(row.querySelectorAll('[data-sabor]'), function (b) {
          b.setAttribute('aria-pressed', c > 0 ? 'true' : 'false');
        });

        var g = add.dataset.group;
        if (g) porGrupo[g] = (porGrupo[g] || 0) + c;
      });

      this.pintarComposicion(porGrupo);

      /* Un tipo lleno se apaga en el sitio. Ver que no se puede es mejor
         que enterarse por un aviso despues de haber tocado. El menos
         sigue vivo: hay que poder deshacer sin recargar. */
      var comp_r = this.cupos();
      Array.prototype.forEach.call(this.querySelectorAll('.mz-sab__row'), function (row) {
        var add = row.querySelector('[data-sabor]');
        if (!add) return;
        var g = add.dataset.group, lleno = false;
        if (comp_r && g) {
          var cupo = comp_r[g] == null ? 0 : comp_r[g];
          lleno = (porGrupo[g] || 0) >= cupo;
        }
        row.classList.toggle('is-lleno', lleno);
        Array.prototype.forEach.call(row.querySelectorAll('[data-sabor]'), function (b) {
          b.disabled = lleno;
        });
      });

      this.pintarDesplegables(porGrupo);

      Array.prototype.forEach.call(this.querySelectorAll('[data-mz-gcount]'), function (el) {
        var c = porGrupo[el.dataset.mzGcount] || 0;
        el.textContent = c;
        el.classList.toggle('is-full', c > 0);
      });

      if (this.progress) {
        this.progress.textContent = this.sel.length + ' de ' + this.N + (faltan === 0 ? ' · lista' : '');
        this.progress.classList.toggle('is-full', faltan === 0);
      }

      /* Resumen: exactamente lo que va a leer Liz.
         Las fijas van en la lista: la canasta las lleva, aunque el
         cliente no las haya elegido, y el pedido debe decirlo.
         Sin el prefijo "N manzanas —": el numero ya se deduce de la
         suma y solo estorbaba la lectura de los sabores. */
      var g = this.agrupado();
      if (this.FIJAS > 0) {
        g = [{ id: '_fija', nombre: this.fijoNombre, n: this.FIJAS, choc: '' }].concat(g);
      }
      /* "2 × Oreo® Molido (Blanco)". El parentesis solo aparece cuando
         hay chocolate que decir: el Tamarindo no lo lleva y ponerle uno
         vacio ensuciaria la comanda. */
      var linea = g.map(function (x) {
        return x.n + ' × ' + x.nombre + (x.choc ? ' (' + chocoCorto(x.choc) + ')' : '');
      }).join(' · ');
      this.summary.textContent = linea;

      /* Propiedades. Solo viaja el valor si la canasta cuadra con lo
         que promete la variante, no solo con el numero de huecos. */
      var cumple = this.composicionCumplida();
      var valor = linea;
      this.propEl.value = cumple ? valor : '';
      this.jsonEl.value = JSON.stringify(g.map(function (x) {
        return { id: x.id, n: x.n, choc: x.choc || '' };
      }));
      if (this.oldEl) this.oldEl.value = this.propEl.value;
      if (valor.length > 600) console.warn('[mz-sabores] propiedad de ' + valor.length + ' caracteres');

      /* El botón ES el contador. Nunca lleva disabled: sigue siendo
         enfocable y accionable, y al activarse incompleto te lleva al hueco. */
      if (this.submit) {
        /* Puede estar llena de numero y mal de composicion: cuatro
           elegidas pero tres Premium donde cabe una. El boton dice
           entonces QUE falta, no "ya esta". */
        var completo = faltan === 0 && cumple;
        var pendientes = this.faltantes();
        var textoFalta;
        if (faltan > 0 && pendientes.length === 0) {
          textoFalta = faltan === 1 ? 'Te falta 1 manzana' : 'Te faltan ' + faltan + ' manzanas';
        } else {
          var suman = pendientes.reduce(function (a, x) { return a + x.faltan; }, 0);
          textoFalta = (suman === 1 ? 'Te falta ' : 'Te faltan ') +
            this.listar(pendientes.map(function (x) { return x.faltan + ' ' + x.nombre; }));
        }
        this.submit.textContent = completo
          ? 'Agregar al carrito' + this.precioSufijo()
          : textoFalta;
        this.submit.classList.toggle('mz-btn--accent', completo);
        this.submit.classList.toggle('mz-btn--ghost', !completo);
        this.submit.setAttribute('aria-disabled', completo ? 'false' : 'true');
      }

      /* EL RESCATE DEL FOCO. Si al que lo tenia lo dejamos deshabilitado,
         escondido dentro de una lista con hidden, o lo barrio el repintado
         de la charola, hay que ponerlo en algun sitio o se pierde.
         Primero se busca quedarse en el mismo renglon —es el caso del menos,
         que se esconde al llegar a cero y tiene el mas justo al lado—, y si
         ahi ya no queda nada vivo se va a la cabecera del grupo que el
         acordeon acaba de abrir, que es a donde toca ir. Cuando no queda
         ningun grupo pendiente, al boton de compra. */
      if (focoPrevio && (focoPrevio.disabled || !this.contains(focoPrevio) ||
                         (focoPrevio.closest && focoPrevio.closest('[hidden]')))) {
        var fila = focoPrevio.closest ? focoPrevio.closest('.mz-sab__row') : null;
        var vecino = fila ? fila.querySelector('[data-sabor]:not([disabled])') : null;
        if (vecino && vecino.closest('[hidden]')) vecino = null;
        var destino = vecino ||
          (this.abierto ? this.querySelector('[data-mz-gtoggle="' + this.abierto + '"]') : this.submit);
        if (destino && typeof destino.focus === 'function') {
          try { destino.focus(); } catch (e) {}
        }
      }
    }

    decir(msg) { if (this.announce) this.announce.textContent = msg; }
  }

  if (!customElements.get('mz-sabores')) customElements.define('mz-sabores', MzSabores);

  /* Aqui vivia un guardian que desactivaba las propiedades de nota
     vacias antes de enviar, para que no salieran como renglones en
     blanco en el pedido. Ya no hace falta: properties[Notas] no existe
     y properties[Nota de regalo] se retiro de la ficha —la nota es del
     pedido y ahora se pide una sola vez en el carrito, como cart.note,
     donde una cadena vacia simplemente no guarda nada. */

  /* Al enviar incompleto no se agrega: se lleva al primer hueco. */
  document.addEventListener('submit', function (ev) {
    var f = ev.target;
    var el = f.querySelector && f.querySelector('mz-sabores');
    if (!el || !el.sel) return;
    /* Dos motivos para no dejar pasar: faltan Manzzanis, o estan todas
       pero no son las que la canasta promete. El segundo es el que
       costaba dinero. */
    var pendientes = el.faltantes ? el.faltantes() : [];
    if (el.sel.length !== el.N || pendientes.length) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      if (pendientes.length) {
        var caja = el.querySelector('[data-mz-cap]');
        if (caja && !caja.hidden) {
          caja.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'center' });
          caja.classList.add('is-pulse');
          setTimeout(function () { caja.classList.remove('is-pulse'); }, 600);
        }
        var suman = pendientes.reduce(function (a, x) { return a + x.faltan; }, 0);
        el.decir((suman === 1 ? 'Te falta ' : 'Te faltan ') +
          el.listar(pendientes.map(function (x) { return x.faltan + ' ' + x.nombre; })) +
          ' para completar esta canasta.');
        return;
      }
      var hueco = el.querySelector('.mz-sab__slot:not(.is-full)');
      if (hueco) {
        hueco.scrollIntoView({ behavior: REDUCE ? 'auto' : 'smooth', block: 'center' });
        hueco.classList.add('is-pulse');
        setTimeout(function () { hueco.classList.remove('is-pulse'); }, 600);
      }
      var f = el.N - el.sel.length;
      el.decir(f === 1 ? 'Te falta 1 manzana por elegir.' : 'Te faltan ' + f + ' manzanas por elegir.');
    }
  }, true);
})();
